<template>
  <v-dialog
    v-model="opened"
    content-class="dtp-settings"
    max-width="350"
    persistent
  >
    <h3 class="dtp-settings__title">
      {{ $t('workersList.displayedColumns') }}
    </h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <v-form
      class="dtp-settings__form"
      @submit.prevent="
        () => {
          $emit('update', activeColumns);
          opened = false;
        }
      "
    >
      <div class="dtp-settings__form-fields">
        <template v-for="option in options">
          <div
            v-if="option.sections"
            class="dtp-settings__section"
            :key="option.title"
          >
            <h4>{{ $t(option.title) }}</h4>

            <div
              v-for="section in option.sections"
              :key="section.key"
              class="dtp-settings__option"
            >
              <v-checkbox
                v-model="activeColumns"
                color="warning"
                hide-details
                :value="section.key"
                :label="$t(section.title)"
              />
            </div>
          </div>

          <div v-else class="dtp-settings__option" :key="option.key">
            <v-checkbox
              v-model="activeColumns"
              color="warning"
              hide-details
              :value="option.key"
              :label="$t(option.title)"
            />
          </div>
        </template>
      </div>

      <v-btn type="submit" class="mt-5" color="warning" elevation="0" block>
        {{ $t('common.btns.save') }}
      </v-btn>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  model: {
    event: 'change',
    prop: 'value',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    visibleColumns: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    activeColumns: [],

    options: [
      { title: 'common.fields.phone', key: 'dtp-phone' },
      { title: 'common.fields.fullName', key: 'dtp-name' },
      { title: 'common.fields.status', key: 'dtp-status' },
      { title: 'dtp.date', key: 'dtp-date' },
      { title: 'dtp.culprit', key: 'dtp-culprit' },
      { title: 'dtp.damageDescription', key: 'dtp-damage-description' },
      { title: 'dtp.isHidden', key: 'dtp-hidden' },
      {
        title: 'dtp.narcology',
        sections: [
          { title: 'dtp.narcology', key: 'dtp-narcology' },
          { title: 'dtp.requestDate', key: 'dtp-narcology-request-date' },
          { title: 'dtp.conclusion', key: 'dtp-narcology-conclusion' },
          { title: 'dtp.conclusionDate', key: 'dtp-narcology-conclusion-date' },
        ],
      },
      {
        title: 'dtp.insurance',
        sections: [
          {
            title: 'dtp.insuranceRequest',
            key: 'dtp-insurance-request',
          },
          { title: 'dtp.insuranceName', key: 'dtp-insurance-name' },
          {
            title: 'dtp.insuranceRequestDate',
            key: 'dtp-insurance-request-date',
          },
          { title: 'dtp.insuranceType', key: 'dtp-insurance-type' },
        ],
      },
      {
        title: 'dtp.materials',
        sections: [
          { title: 'dtp.materials', key: 'dtp-materials' },
          { title: 'dtp.receivingDate', key: 'dtp-materials-receiving-date' },
        ],
      },
      {
        title: 'dtp.assessmentReferral',
        sections: [
          { title: 'dtp.assessmentReferral', key: 'dtp-assessment-referral' },
          { title: 'dtp.receivingDate', key: 'dtp-assessment-receiving-date' },
          { title: 'dtp.assessmentName', key: 'dtp-assessment-name' },
        ],
      },
      {
        title: 'dtp.grade',
        sections: [
          { title: 'dtp.grade', key: 'dtp-grade' },
          { title: 'dtp.passDate', key: 'dtp-grade-pass-date' },
          { title: 'dtp.reportDate', key: 'dtp-grade-report-date' },
          { title: 'dtp.gradeAmount', key: 'dtp-grade-amount' },
        ],
      },
      {
        title: 'dtp.autoRecovery',
        sections: [
          { title: 'dtp.autoRecovery', key: 'dtp-auto-recovery' },
          { title: 'dtp.troubleshootingType', key: 'dtp-troubleshooting-type' },
          { title: 'dtp.troubleshootingDate', key: 'dtp-troubleshooting-date' },
          {
            title: 'dtp.troubleshootingAmount',
            key: 'dtp-troubleshooting-amount',
          },
          {
            title: 'dtp.coordinationWithOwner',
            key: 'dtp-coordination-with-owner',
          },
          { title: 'dtp.readyStatus', key: 'dtp-ready-status' },
          {
            title: 'dtp.troubleshootingEndDate',
            key: 'dtp-troubleshooting-end-date',
          },
        ],
      },
      {
        title: 'dtp.pay',
        sections: [
          { title: 'dtp.pay', key: 'dtp-pay' },
          { title: 'dtp.courtStatement', key: 'dtp-court-statement' },
          {
            title: 'dtp.paymentApplicationDate',
            key: 'dtp-payment-application-date',
          },
          { title: 'dtp.paymentDate', key: 'dtp-payment-date' },
          { title: 'dtp.paymentAmount', key: 'dtp-payment-amount' },
        ],
      },
    ],
  }),
  watch: {
    opened(val) {
      if (val) {
        this.activeColumns = this.visibleColumns;
      }
    },
  },
  computed: {
    opened: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit('change', val);
      },
    },
  },
};
</script>

<style lang="scss">
.dtp-settings {
  padding: 10px;
  background-color: #fff;

  &__title {
    color: #424242;
    margin-bottom: 10px;
  }

  &__form-fields {
    max-height: 400px;
    overflow-y: auto;
  }

  &__option {
    max-width: 300px;
    width: 100%;
    padding-left: 10px;
  }

  &__section {
    h4 {
      padding-left: 10px;
    }

    margin-top: 15px;
    margin-bottom: 15px;
  }

  .v-input .v-label {
    height: auto;
  }

  .v-input--checkbox {
    margin-top: 5px;
  }
}
</style>
